import * as questionIds from "../../consultationQuestions/questionIds";

export const drugAlcoholTestQuestions = [
    {
        id: questionIds.DrugAlcoholTestUnableToCarryOut,
        questionText: "Unable to carry out medical",
    },
    {
        id: questionIds.DrugAlcoholTestUnableToCarryOutReason,
        questionText: "Reason medical not carried out",
    },
    {
        id: questionIds.InstantSubstanceAbuseTest,
        questionText: "Instant Substance Abuse Test",
    },
    {
        id: questionIds.InstantSubstanceAbuseTestResults,
        questionText: "Results",
    },
    {
        id: questionIds.LabSubstanceAbuseTest,
        questionText: "Lab Substance Abuse Test",
    },
    {
        id: questionIds.AlcoholBreathTest,
        questionText: "Alcohol Breath Test",
    },
    {
        id: questionIds.AlcoholBreathTestResults,
        questionText: "Results",
    },
];
